import { twMerge } from 'tailwind-merge'

/**
 * Small className combiner used across the design system.
 * Filters falsy values and merges Tailwind classes safely.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return twMerge(classes.filter(Boolean).join(' '))
}
